export enum FileExtension {
  csv = 'csv',
  xlsx = 'xlsx',
}
